import { FunctionComponent as F } from 'react';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PageHeadline from '../components/UI/Text/PageHeadline';

const Contact: F = () =>
{
  return (
    <Container>
      <Stack
        direction='column'
        justifyContent='center'
        alignItems='center'
        spacing={2}>

        <PageHeadline>Contact</PageHeadline>

        <Typography>
          What is the intention behind Protoplan?
        </Typography>

      </Stack>
    </Container>);
};

export default Contact;
